import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Collapse } from "@mui/material";
import { useTranslation } from "react-i18next";

const Accordion = ({ title, children, isOpen, toggle }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        boxShadow:
          "rgba(33, 41, 52, 0.06) 0px 1px 2px, rgba(33, 41, 52, 0.1) 0px 1px 3px",
        borderRadius: "0.375rem", // Equivalent to Tailwind's rounded-md
        marginBottom: "1rem", // Equivalent to Tailwind's mb-3
      }}
    >
      <Button
        sx={{
          width: "100%",
          padding: "0.75rem", // Equivalent to Tailwind's p-3
          textAlign: "left",
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: "#f5f5f5", // Equivalent to Tailwind's hover:bg-gray-100
          },
          transition: "background-color 0.3s",
          borderBottom: isOpen ? "1px solid rgba(0, 0, 0, 0.12)" : "none",
          boxShadow: isOpen ? "0px 1px 2px rgba(0, 0, 0, 0.1)" : "none",
          display: "flex",
          justifyContent: "space-between",
          color: "black",
        }}
        onClick={toggle}
      >
        {t(title)}
        <Box
          component="span"
          sx={{
            float: "right",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s",
          }}
        >
          <FontAwesomeIcon icon={faCaretDown} />
        </Box>
      </Button>
      <Collapse in={isOpen}>
        <Box
          sx={{
            padding: "1rem",
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};

export default Accordion;
